// extracted by mini-css-extract-plugin
export default {"root":"UploadInput__root--3HaT_"};